'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof String.prototype.padStart === 'function' ? String.prototype.padStart : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/string.prototype.padstart/polyfill.js
// module id = 279
// module chunks = 0